var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVerified20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4 7.5998C14 7.1998 13.4 7.1998 13 7.5998L8.99999 11.5998L6.99999 9.5998C6.59999 9.1998 5.99999 9.1998 5.59999 9.5998C5.19999 9.9998 5.19999 10.5998 5.59999 10.9998L8.29999 13.6998C8.49999 13.8998 8.69999 13.9998 8.99999 13.9998C9.29999 13.9998 9.49999 13.8998 9.69999 13.6998L14.4 8.9998C14.8 8.5998 14.8 7.9998 14.4 7.5998Z",
  fill: "currentColor"
})));
export { SvgVerified20 as ReactComponent };